@if (selectedCustomer) {
  <div class="customer-selector" data-test="customer-picker">
    <mat-form-field class="customer-selector__input-container" data-test="account-input-container">
      @if (loading) {
        <mat-progress-spinner mode="indeterminate" diameter="20"></mat-progress-spinner>
      }
      <input
        class="customer-selector__input"
        type="text"
        matInput
        #customerInput
        [matAutocomplete]="auto"
        [value]="onFocusName ? '' : selectedCustomer.name"
        (focus)="onFocus($event)"
        (blur)="onBlur()"
        (keyup)="onKeyUp($event)" />
      @if (selectableCustomers) {
        <mat-icon class="customer-selector__icon">keyboard_arrow_down</mat-icon>
      }
    </mat-form-field>
    <mat-autocomplete class="customer-selector__autocomplete" #auto="matAutocomplete">
      @for (customer of filteredCustomers; track customer) {
        <mat-option class="customer-selector__autocomplete-option" (click)="onOptionClick(customer.id)">
          {{ customer.name }}
        </mat-option>
      }
    </mat-autocomplete>
  </div>
}
